module.exports = __webpack_public_path__ + "img/hacken-white.13edf29c.svg";